import { action, extendObservable } from 'mobx';

import ModelBase from './ModelBase';
import Bonus from './Bonus';

export default class ContactDetails extends ModelBase {
  static className = 'ContactDetails';

  @action static fromJSON(id, json) {
    const result = super.fromJSON(id, json);

    if (!result.actions) {
      extendObservable(result, { actions: [] });
    }

    if (json.bonuses) {
      extendObservable(result, {
        bonuses: json.bonuses.map(b => Bonus.fromJSON(b.recId, b))
      });
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/ContactDetails.js